export default __webpack_public_path__ + "static/media/skater-girl-left-leg-forward.98575742.png";